export const getSubscriptionsQuery = async () =>
    fetch('/api/v2/accounts/subscription/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });

export const getPaymentMethodsQuery = async () =>
    fetch('/api/v2/accounts/payment-methods/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });

export const createPaymentMethodsQuery = async (body) =>
    fetch('/api/v2/accounts/payment-methods/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(body),
    });
